/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-30 09:26:49
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-24 17:19:27
 */
import request from "../../utils/request";
import server from "./config";
const getOpenidByCodeUrl = `${server.MS_PATIENT_CONSUMMER}/wxmp/{version}/getOpenidByCode`;
export default {
    getOpenidByCodeUrl,
    /**
     * 获取微信js_sdk config
     */
    jsconfig: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/wxmp/1/getJsconfig`,
            method: "post",
            data
        });
    },
    getAudio() {
        return `${process.env.BASE_URL}${server.MS_PATIENT_CONSUMMER}/wxmp/1/getResourceByMediaId/`;
    },
    showGroupTagList(data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patientWechatArticle/1/showGroupTagList`,
            method: "post",
            data
        });
    },
    showWechatArticleList(data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patientWechatArticle/1/showWechatArticleList`,
            method: "post",
            data
        });
    },
    wechatArticleClassifyPageList(data) {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patientWechatArticle/1/wechatArticleClassifyPageList`,
            method: "post",
            data
        });
    },
    /**
     * 根据code获取openid
     */
    getOpenidByCode: data => {
        return request({
            url: getOpenidByCodeUrl,
            method: "post",
            data
        });
    },

    // 埋点send
    sendMsg: data => {
        return request({
            url: `${process.env.BURIED_POINT_URL}buried/sendMsg`,
            method: "post",
            data
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/modules/wx.js